import { Subscription } from 'rxjs';

import {
  Component,
  HostBinding,
  ChangeDetectorRef,
  OnDestroy,
  AfterViewInit,
  Input,
  OnInit,
  ViewRef,
} from '@angular/core';
import {
  Router,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
} from '@angular/router';

import { TopBarService } from './topbar.service';
import { IBreadcrumb, Breadcrumb } from '../../services/breadcrumb';

@Component({
  selector: 'topbar',
  styleUrls: ['./topbar.component.scss'],
  templateUrl: './topbar.component.html',
})
export class TopbarComponent implements OnInit, AfterViewInit, OnDestroy {
  @HostBinding('class') public className: string = 'ui menu borderless';
  @Input() public isMobileAppHeader: boolean;
  public breadcrumb: IBreadcrumb;
  public backLink: string;
  public isNavigating: boolean = false;
  private routerSubscription: Subscription;

  constructor(
    topBarService: TopBarService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private breadcrumbService: Breadcrumb,
  ) {
    this.breadcrumbService.registerComponent(this);
    this.subscribeToRouteChange();
    topBarService.getBackLink$().subscribe((link: string): void => {
      this.backLink = link;
    });
  }

  public ngOnInit(): void {
    if (this.isMobileAppHeader) {
      this.className += ' mobile-header';
    }
  }

  public ngAfterViewInit(): void {
    this.cdr.detach();
  }

  public ngOnDestroy(): void {
    this.routerSubscription.unsubscribe();
  }

  public update(breadcrumb: IBreadcrumb): void {
    this.breadcrumb = breadcrumb;
    if (!(this.cdr as ViewRef).destroyed) this.cdr.detectChanges();
  }

  public subscribeToRouteChange(): void {
    this.routerSubscription = this.router.events
      .subscribe(e => {
        if (e instanceof NavigationStart) {
          this.isNavigating = true;
        } else if (e instanceof NavigationEnd || e instanceof NavigationCancel) {
          this.isNavigating = false;
        }
        this.cdr.detectChanges();
      });
  }
}
